module.exports = __webpack_public_path__ + "img/saudi-arabia.ec0152f0.svg";